import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import './Navbar.css'
import logo from '../../utils/assets/images/logo.png'
import cabinetLogo from '../../utils/assets/images/cabinet-logo.png'
const NavbarComponent = () => {
    return (
        <div className='navbar-wrapper sticky-top' >
            <Navbar expand="lg" className="bg-body-tertiary">
          <div className='ctr'>
           <div className='navbar-wrapper-content'>
           <Navbar.Brand ><img src={cabinetLogo}/></Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto">
                <Nav.Link href="#scale-up">Scale-up in Egypt</Nav.Link>
                <Nav.Link href="#stakeholders">Stakeholders</Nav.Link>
                <Nav.Link href="#pipeline">Pipeline</Nav.Link>
                <Nav.Link href="#production-capacity">Production Capacity</Nav.Link>
                <Nav.Link href="#process-summary">Process Summary</Nav.Link>
              </Nav>
            </Navbar.Collapse>
           </div>
          </div>
        </Navbar>
        </div>
      );
}
 


export default NavbarComponent;